"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Calendar } from "lucide-react";
export default function ContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative bg-dark-background py-16 px-4">
      <div className="mx-auto max-w-2xl text-center">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h2 className="mb-2 text-3xl font-bold text-foreground md:text-4xl">
            Ready to Transform Your Smile?
          </h2>
          <p className="mb-1 text-lg text-foreground">
            Schedule your appointment today and experience compassionate,
            family-friendly dental care.
          </p>
          <div className="mb-8 h-1 w-24 mx-auto bg-secondary rounded-full" />

          <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=">
            <Button size="lg" className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-[0_8px_24px_rgba(0,0,0,0.2)] hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] focus-visible:ring-2 focus-visible:ring-ring">
              <SafeHydrate><Calendar className="size-5" /></SafeHydrate>
              Schedule With Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}